import SideBarMenu from '@/view/sidebar/domain/SideBarMenuItem';

export const menuItems: SideBarMenu[] = [
    {
        id: 1,
        title: 'EMAIL',
        type: 'header',
    }, {
        id: 2,
        title: 'Subscriptions',
        route: 'manage-subscriptions',
        type: 'button',
    },
];
